import React, { useEffect, useState } from "react";

import { Container, ContentHeader, List, TableColumns } from "./styles";

import HistoryListItem from "../HistoryListItem/HistoryListItem";
import ModalViewClients from "../ModalViewClients/ModalViewClients";

import Modal from "react-modal";
import { FiSearch } from "react-icons/fi";
import { Menu } from "@mui/material";
import {
  CancelButton,
  ClearSearch,
  SearchBar,
  SearchButton,
  SearchContainer,
} from "@components/DataTable/styles";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { toast } from "react-toastify";
import { alertErrorStyle } from "@resources/alertErrorStyle";
import ModalConfirm from "@components/Modal/ModalConfirm/ModalConfirm";
import { RemoveHistory } from "@domain/models/RemoveHistory";
import useAlgolia from "@hooks/useAlgolia";
import { GetClientRemovalsUseCase, UndoRemoveClientsUseCase } from "@useCases/index";
import { HttpClientRemovalsRepository } from "@data/repositories/Http/HttpClientRemovalsRepository";
import { api } from "@data/api";
import { arrayHelper } from "@helpers/array";
import { HttpRemoveRepository } from "@data/repositories/index";
import { RemoveJob } from "@domain/models/RemoveJob";

type Props = {
  removeHistory: RemoveHistory[];
  onUndoRemove: (job: RemoveJob) => void;
};

export default function HistoryList({ removeHistory, onUndoRemove }: Props) {
  const { algoliaSearchResult } = useAlgolia();

  //   const { undoRemoveClientsFromMap } = useRemove();

  const [modalVisible, setModalVisible] = useState(false);
  const [modalUndo, setModalUndo] = useState(false);

  const [modalLoading, setModalLoading] = useState(false);

  const [selectedHistory, setSelectedHistory] = useState<RemoveHistory>(null);
  const [filteredHistory, setFilteredHistory] = useState<RemoveHistory[]>([]);

  const [search, setSearch] = useState("");
  const [draftSearch, setDraftSearch] = useState("");
  const [searchBar, setSearchBar] = useState(null);
  const openSearch = Boolean(searchBar);

  useEffect(() => {
    if (search) {
      searchHistoryList();
    }
  }, [search]);

  const handleView = async (data) => {
    setSelectedHistory(data);
    setModalVisible(true);
  };

  const searchHistoryList = () => {
    algoliaSearchResult(search).then((clients) => {
      if (clients.length > 0) {
        const client = clients[0];

        const useCase = new GetClientRemovalsUseCase(new HttpClientRemovalsRepository(api));

        useCase.execute(client.id).then((clientRemovals) => {
          if (clientRemovals.length > 0) {
            const removalsIds = arrayHelper.reduceToSimple(clientRemovals, "id");

            const newHistory = removeHistory.filter((x) => removalsIds.includes(x.id));
            setFilteredHistory(newHistory);
          }
        });
      }
    });
  };

  const clearOperation = () => {
    setModalLoading(false);
    setModalUndo(false);
    setSelectedHistory(null);
  };

  const clearSearch = () => {
    setSearch("");
    setDraftSearch("");
  };

  const handleSearch = () => {
    setSearchBar(null);
    setSearch(draftSearch);
  };

  const handleUndoRemove = async (item: RemoveHistory) => {
    setModalLoading(true);

    if (item.removedClients > 0) {
      const useCase = new UndoRemoveClientsUseCase(new HttpRemoveRepository(api));

      useCase
        .execute(item.id)
        .then((job) => {
          onUndoRemove(job);
        })
        .finally(() => {
          clearOperation();
          setModalLoading(false);
        });
    } else {
      toast("Nenhum cliente a ser devolvido ao mapa", alertErrorStyle);
      clearOperation();
    }
  };

  const listData = search ? filteredHistory : removeHistory;

  return (
    <Container>
      <ContentHeader>
        <h4>Histórico de remoções</h4>

        <div>
          <FiSearch
            onClick={(event) => {
              setSearchBar(event.currentTarget);
            }}
            size={20}
            cursor="pointer"
            color="var(--grey2)"
          />
          <ClearSearch>
            {draftSearch && (
              <>
                {draftSearch}
                <AiOutlineCloseCircle cursor="pointer" onClick={() => clearSearch()} />
              </>
            )}
          </ClearSearch>
        </div>
      </ContentHeader>
      <TableColumns>
        <h3>Administrador</h3>
        <h3>Status</h3>
        <h3>Resultado</h3>
        <h3>Descrição</h3>
        <h3>Data da retirada</h3>
        <h3>Excluídos</h3>
        <h3>Não excluídos</h3>
        <h3>Total</h3>
        <h3>Ações</h3>
      </TableColumns>
      <List>
        {listData &&
          listData.map((item, index) => (
            <HistoryListItem
              key={index}
              data={item}
              onView={() => handleView(item)}
              onUndo={() => {
                setSelectedHistory(item);
                setModalUndo(true);
              }}
            />
          ))}
      </List>
      <Modal
        isOpen={modalVisible}
        onRequestClose={() => {
          setModalVisible(false);
        }}
        overlayClassName="modal-overlay"
        className="modal-content-auto-width"
        contentLabel="Example Modal"
      >
        <ModalViewClients history={selectedHistory} onClose={() => setModalVisible(false)} />
      </Modal>

      <Modal
        isOpen={modalUndo}
        onRequestClose={() => {
          setModalUndo(false);
        }}
        overlayClassName="modal-overlay"
        className="modal-content-auto-width"
        contentLabel="Example Modal"
      >
        <ModalConfirm
          text="Tem certeza que deseja desfazer a remoção de clientes?"
          option="Desfazer remoção"
          loading={modalLoading}
          onCancel={() => setModalUndo(false)}
          onConfirm={() => handleUndoRemove(selectedHistory)}
        />
      </Modal>

      <Menu
        id="basic-menu"
        anchorEl={searchBar}
        open={openSearch}
        onClose={() => {
          setSearchBar(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          style: {
            width: 600,
            height: 40,
            maxHeight: 40,
            borderRadius: 20,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            overflow: "hidden",
          },
        }}
      >
        <SearchContainer
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}
        >
          <FiSearch size={18} cursor="pointer" color="#626F87" strokeWidth="3" />
          <p>&#8288;</p>
          <SearchBar>
            <input
              name="draftSearch"
              onChange={(event) => setDraftSearch(event.target.value)}
              value={draftSearch}
              placeholder="Buscar..."
              autoFocus={true}
            />
          </SearchBar>
          <CancelButton
            onClick={() => {
              setSearchBar(null);
            }}
          >
            Cancelar
          </CancelButton>
          <SearchButton onClick={() => handleSearch()}>Buscar</SearchButton>
        </SearchContainer>
      </Menu>
    </Container>
  );
}
